module.exports = __webpack_public_path__ + "img/angle-up-sharp-light.fd18d47d.svg";